import OtaImportWizard from "./OtaImportWizard";

const exports = {
    Page: OtaImportWizard,
};
export default exports;
